import { logei, Locale_get_FromSelectedLanguage, logwi, stripHtmlTags, luhn, DateTimeExtensions_toDate, Locale$reflection, parseInt$, ssnOrOrgNrToValidFormat, getIdNumberType } from "../../Utils.js";
import { printf, toText, isNullOrWhiteSpace, replace } from "../../fable_modules/fable-library.3.7.20/String.js";
import { EmptyOrRange1To31Module_create, AlphaNumeric40Module_create, String32OrEmptyModule_create, String40Module_create, AlphaNumeric40Module_value, String40Module_value, String32OrEmptyModule_value } from "../../Validation/Common.js";
import { PeppolIdModule_create, PeppolIdModule_createNonEmpty, CityModule_create, ZipCodeModule_create, PostalAttentionModule_create, EmailModule_create, ContactNumberModule_create, CustomerGroupCodeModule_create, OrganisationNumberModule_create, InvoiceeNrModule_create, ZipCodeModule_value, CityModule_value, PostalAttentionModule_value, PeppolIdModule_value, InvoiceeNrModule_value, EmailModule_value, CustomerGroupCodeModule_value, ContactNumberModule_value } from "../../Validation/Invoicee.js";
import { DistributionModule_getOptions, VatModeModule_getOptions, NoNextInvoice_getNoNextInvoiceOptions, BillingIntervalModule_getMonthlyBillingIntervalOptions, VatMode, InvoiceeTypeModule_ofString, InvoiceeTypeModule_getOptions, InvoiceeTypeModule_ofStringSafe, Distribution, IsoCountryCode$reflection, InvoiceeTypeModule_toString, VatModeModule_toString, DistributionModule_toString, VatModeModule_ofString, VatModeModule_toExclVat, DistributionModule_ofString, DistributionModule_toCode } from "../../DomainTypes.js";
import { defaultArgWith, map, some, bind } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { Section, DetailsSectionViewModel, DetailsValidation2, CreateInvoiceeDTO$reflection, ValidDetails, CreateInvoiceeDTO } from "./Model.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { forAll, isEmpty, filter, cons, tryHead, empty, singleton as singleton_1, ofArray, choose } from "../../fable_modules/fable-library.3.7.20/List.js";
import { equals, uncurry, partialApply } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { toString, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { list_type, record_type, unit_type, lambda_type, class_type, union_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { countryOptions, Country$reflection, CreditCheckDTO$reflection } from "../CustomerContract/Common.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { LoadState_defaultValue, SaveStatus, GlobalDependencies$reflection, LoadState$2, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { dotsLoading } from "../../ViewUtils.js";
import { errors, success, warning } from "../../Components/Message/Message.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { ButtonKind, wrappedButton, secondary, ButtonProps, defaultProps, main } from "../../Components/Button/Button.js";
import { SelectOption, ValueProp as ValueProp_6, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { renderModal } from "../../Components/Modals/Choice/Choice.js";
import { ModalSize, getModalContainer, modal } from "../../Components/Modal/Modal.js";
import { MessageType, render as render_2 } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { empty as empty_1, singleton as singleton_2, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { saveNewInvoicee, loadCreditCheck as loadCreditCheck_1, loadExistingInvoicee } from "./Api.js";
import { getSavePanel } from "../../Components/SavePanel/SavePanel.js";
import { SectionState, getProgressIcon } from "../../Components/ProgressIcon/ProgressIcon.js";
import { loadCountriesThunk } from "../../Api/Misc.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { toString as toString_1 } from "../../fable_modules/fable-library.3.7.20/Long.js";
import "../../../src/Containers/RegisterInvoicee/View.scss";


function getInvoiceeTypeAndFormattedSSN(countryCode, orgnrOrSSN) {
    const idNumberType = getIdNumberType(orgnrOrSSN, countryCode);
    return [idNumberType, (idNumberType.tag === 1) ? ssnOrOrgNrToValidFormat(orgnrOrSSN, countryCode) : ((idNumberType.tag === 0) ? ((countryCode.ThreeLetter === "SWE") ? replace(orgnrOrSSN, "-", "") : orgnrOrSSN) : orgnrOrSSN)];
}

function getCreateInvoiceeDTO(omniChannel, languageCode, validDetails) {
    let value_1;
    return new CreateInvoiceeDTO(String32OrEmptyModule_value(validDetails.Reference), void 0, ContactNumberModule_value(validDetails.ContactNumber), String32OrEmptyModule_value(validDetails.ContactPerson), void 0, CustomerGroupCodeModule_value(validDetails.CustomerGroupCode), (omniChannel != null) ? ((omniChannel > 10) ? ((value_1 = (omniChannel | 0), 1)) : DistributionModule_toCode(DistributionModule_ofString(validDetails.Distribution))) : DistributionModule_toCode(DistributionModule_ofString(validDetails.Distribution)), EmailModule_value(validDetails.Email), VatModeModule_toExclVat(VatModeModule_ofString(validDetails.VatMode)), (languageCode === "nb") ? "no" : languageCode, bind((arg_5) => parseInt$(InvoiceeNrModule_value(arg_5)), validDetails.InvoiceeNr), validDetails.InvoiceeType, parse(validDetails.InvoiceInterval, 511, false, 32), String40Module_value(validDetails.Name), PeppolIdModule_value(validDetails.PeppolId), AlphaNumeric40Module_value(validDetails.StreetAddress), PostalAttentionModule_value(validDetails.CO), CityModule_value(validDetails.City), ZipCodeModule_value(validDetails.ZipCode), validDetails.Country);
}

export function getValidDetails(getTranslation, vm, validation) {
    const invoiceeNrResult = validation.InvoiceeNr(vm.InvoiceeNr);
    const paymentTermsFixedDay = validation.PaymentTermsFixedDay(vm.PaymentTermsFixedDay);
    const ourReference = validation.OurReference(vm.OurReference);
    const reference = validation.Reference(vm.Reference);
    const peppolAddress = validation.PeppolAddress(vm.PeppolAddress);
    const co = validation.CO(vm.CO);
    const city = validation.City(vm.City);
    const zipCode = validation.ZipCode(vm.ZipCode);
    const streetAddress = validation.Address(vm.StreetAddress);
    const email = validation.Email(vm.Email);
    const contactNumber = validation.ContactNumber(vm.ContactNumber);
    const contactPerson = validation.ContactPerson(vm.ContactPerson);
    const customerGroupCode = validation.CustomerGroupCode(vm.CustomerGroupCode);
    const orgNr = validation.OrgNr(vm.OrgNr);
    const name = validation.Name(vm.Name);
    const distribution = DistributionModule_toString(vm.Distribution);
    const vat = VatModeModule_toString(vm.VatMode);
    const invoiceeType = InvoiceeTypeModule_toString(vm.InvoiceeType);
    const matchValue = [name, orgNr, customerGroupCode, contactPerson, contactNumber, email, streetAddress, zipCode, city, co, peppolAddress, reference, ourReference, paymentTermsFixedDay, invoiceeNrResult];
    let pattern_matching_result, city_1, co_1, contactNumber_1, contactPerson_1, customerGroupCode_1, email_1, invoiceeNr, name_1, orgNr_1, ourReference_1, paymentTermsFixedDay_1, peppolAddress_1, reference_1, streetAddress_1, zipCode_1;
    const copyOfStruct = matchValue[0];
    if (copyOfStruct.tag === 0) {
        const copyOfStruct_1 = matchValue[1];
        if (copyOfStruct_1.tag === 0) {
            const copyOfStruct_2 = matchValue[2];
            if (copyOfStruct_2.tag === 0) {
                const copyOfStruct_3 = matchValue[3];
                if (copyOfStruct_3.tag === 0) {
                    const copyOfStruct_4 = matchValue[4];
                    if (copyOfStruct_4.tag === 0) {
                        const copyOfStruct_5 = matchValue[5];
                        if (copyOfStruct_5.tag === 0) {
                            const copyOfStruct_6 = matchValue[6];
                            if (copyOfStruct_6.tag === 0) {
                                const copyOfStruct_7 = matchValue[7];
                                if (copyOfStruct_7.tag === 0) {
                                    const copyOfStruct_8 = matchValue[8];
                                    if (copyOfStruct_8.tag === 0) {
                                        const copyOfStruct_9 = matchValue[9];
                                        if (copyOfStruct_9.tag === 0) {
                                            const copyOfStruct_10 = matchValue[10];
                                            if (copyOfStruct_10.tag === 0) {
                                                const copyOfStruct_11 = matchValue[11];
                                                if (copyOfStruct_11.tag === 0) {
                                                    const copyOfStruct_12 = matchValue[12];
                                                    if (copyOfStruct_12.tag === 0) {
                                                        const copyOfStruct_13 = matchValue[13];
                                                        if (copyOfStruct_13.tag === 0) {
                                                            const copyOfStruct_14 = matchValue[14];
                                                            if (copyOfStruct_14.tag === 0) {
                                                                pattern_matching_result = 0;
                                                                city_1 = copyOfStruct_8.fields[0];
                                                                co_1 = copyOfStruct_9.fields[0];
                                                                contactNumber_1 = copyOfStruct_4.fields[0];
                                                                contactPerson_1 = copyOfStruct_3.fields[0];
                                                                customerGroupCode_1 = copyOfStruct_2.fields[0];
                                                                email_1 = copyOfStruct_5.fields[0];
                                                                invoiceeNr = copyOfStruct_14.fields[0];
                                                                name_1 = copyOfStruct.fields[0];
                                                                orgNr_1 = copyOfStruct_1.fields[0];
                                                                ourReference_1 = copyOfStruct_12.fields[0];
                                                                paymentTermsFixedDay_1 = copyOfStruct_13.fields[0];
                                                                peppolAddress_1 = copyOfStruct_10.fields[0];
                                                                reference_1 = copyOfStruct_11.fields[0];
                                                                streetAddress_1 = copyOfStruct_6.fields[0];
                                                                zipCode_1 = copyOfStruct_7.fields[0];
                                                            }
                                                            else {
                                                                pattern_matching_result = 1;
                                                            }
                                                        }
                                                        else {
                                                            pattern_matching_result = 1;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result = 1;
                                                    }
                                                }
                                                else {
                                                    pattern_matching_result = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result = 1;
                                            }
                                        }
                                        else {
                                            pattern_matching_result = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result = 1;
                                }
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new FSharpResult$2(0, new ValidDetails(name_1, invoiceeType, orgNr_1, isNullOrWhiteSpace(InvoiceeNrModule_value(invoiceeNr)) ? (void 0) : invoiceeNr, customerGroupCode_1, contactPerson_1, contactNumber_1, email_1, streetAddress_1, zipCode_1, city_1, co_1, vm.AddressCountry, vat, distribution, vm.InvoiceInterval, vm.InvoiceStatus, peppolAddress_1, reference_1, ourReference_1, paymentTermsFixedDay_1));
        }
        case 1: {
            const getError = (_arg) => {
                if (_arg.tag === 1) {
                    return some(_arg.fields[0]);
                }
                else {
                    return void 0;
                }
            };
            const prepend = (prependTxt, errorMsg) => toText(printf("[%s] %s"))(prependTxt)(errorMsg);
            return new FSharpResult$2(1, choose((x_46) => x_46, ofArray([map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.Name")]), getError(validation.Name(vm.Name))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.OrgNr")]), getError(validation.OrgNr(vm.OrgNr))), map(partialApply(1, prepend, [getTranslation("Common.InvoiceeNr")]), getError(validation.InvoiceeNr(vm.InvoiceeNr))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.CustomerGroup")]), getError(validation.CustomerGroupCode(vm.CustomerGroupCode))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.ContactPerson")]), getError(validation.ContactPerson(vm.ContactPerson))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.ContactNumber")]), getError(validation.ContactNumber(vm.ContactNumber))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.Email")]), getError(validation.Email(vm.Email))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.StreetAddress")]), getError(validation.Address(vm.StreetAddress))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.ZipCode")]), getError(validation.ZipCode(vm.ZipCode))), map(partialApply(1, prepend, [getTranslation("Common.City")]), getError(validation.City(vm.City))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.CO")]), getError(validation.CO(vm.CO))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.PeppolAddress")]), getError(validation.PeppolAddress(vm.PeppolAddress))), map(partialApply(1, prepend, [getTranslation("CustomerContract.RegisterInvoicee.InvoiceReference")]), getError(validation.Reference(vm.Reference))), map(partialApply(1, prepend, [getTranslation("CustomerContract.Invoicee.OurReference")]), getError(validation.OurReference(vm.OurReference))), map(partialApply(1, prepend, [getTranslation("CustomerContract.Invoicee.TermsOfPaymentFixedDay")]), getError(validation.PaymentTermsFixedDay(vm.PaymentTermsFixedDay)))])));
        }
    }
}

export class CreditCheckSectionProps extends Record {
    constructor(Locale, CountryCode, LoadCreditCheckFn, GoToNextSectionFn, OrgNrChangeFn) {
        super();
        this.Locale = Locale;
        this.CountryCode = CountryCode;
        this.LoadCreditCheckFn = LoadCreditCheckFn;
        this.GoToNextSectionFn = GoToNextSectionFn;
        this.OrgNrChangeFn = OrgNrChangeFn;
    }
}

export function CreditCheckSectionProps$reflection() {
    return record_type("Containers.RegisterInvoicee.View2.CreditCheckSectionProps", [], CreditCheckSectionProps, () => [["Locale", Locale$reflection()], ["CountryCode", IsoCountryCode$reflection()], ["LoadCreditCheckFn", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [CreditCheckDTO$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", CreditCheckDTO$reflection()]], [["ErrorValue", string_type]]])]))], ["GoToNextSectionFn", lambda_type(unit_type, unit_type)], ["OrgNrChangeFn", lambda_type(string_type, unit_type)]]);
}

const renderCreditCheckSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let arg_3, arg_2, arg_5, arg_4, children_5, children_3, inputRecord, children_11, children_7, children_9;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const creditCheckLoadState = react.useState(new LoadState$2(0));
    const orgNrState = react.useState("");
    let creditCheckStatusMsgHtml;
    const matchValue = creditCheckLoadState[0];
    switch (matchValue.tag) {
        case 1: {
            creditCheckStatusMsgHtml = dotsLoading;
            break;
        }
        case 3: {
            creditCheckStatusMsgHtml = warning(matchValue.fields[0].split(""));
            break;
        }
        case 2: {
            const creditCheck = matchValue.fields[0];
            creditCheckStatusMsgHtml = (creditCheck.approved ? success(((arg_3 = DateTimeExtensions_toDate(props.Locale.ILocale, creditCheck.date), (arg_2 = getTranslation("CustomerContract.Invoicee.Approved"), toText(printf("%s (%s)"))(arg_2)(arg_3)))).split("")) : warning(((arg_5 = DateTimeExtensions_toDate(props.Locale.ILocale, creditCheck.date), (arg_4 = getTranslation("CustomerContract.Invoicee.NotApproved"), toText(printf("%s (%s)"))(arg_4)(arg_5)))).split("")));
            break;
        }
        default: {
            creditCheckStatusMsgHtml = react.createElement(react.Fragment, {});
        }
    }
    let patternInput;
    const matchValue_1 = creditCheckLoadState[0];
    switch (matchValue_1.tag) {
        case 0: {
            patternInput = [getTranslation("Common.PerformCreditCheck"), false, (_arg_1) => {
                const orgNr = orgNrState[0];
                creditCheckLoadState[1](new LoadState$2(1));
                startImmediate(singleton.Delay(() => singleton.Bind(props.LoadCreditCheckFn(orgNr), (_arg) => {
                    const result = _arg;
                    const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
                    creditCheckLoadState[1](arg);
                    return singleton.Zero();
                })));
            }];
            break;
        }
        case 1: {
            patternInput = [getTranslation("CustomerContract.RegisterInvoicee.LoadingCreditCheck"), true, (value) => {
            }];
            break;
        }
        case 2: {
            patternInput = [getTranslation("Common.Continue"), false, (_arg_2) => {
                props.GoToNextSectionFn();
            }];
            break;
        }
        default: {
            patternInput = [getTranslation("Common.PerformCreditCheck"), false, (_arg_1) => {
                const orgNr = orgNrState[0];
                creditCheckLoadState[1](new LoadState$2(1));
                startImmediate(singleton.Delay(() => singleton.Bind(props.LoadCreditCheckFn(orgNr), (_arg) => {
                    const result = _arg;
                    const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
                    creditCheckLoadState[1](arg);
                    return singleton.Zero();
                })));
            }];
        }
    }
    const children_13 = [(children_5 = [(children_3 = [render_1()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(orgNrState[0], inputRecord.Type, inputRecord.Classes, (e) => {
        const formattedOrgNr = ssnOrOrgNrToValidFormat(Browser_Types_Event__Event_get_Value(e), props.CountryCode);
        props.OrgNrChangeFn(formattedOrgNr);
        orgNrState[1](formattedOrgNr);
    }, inputRecord.Disabled, getTranslation("CustomerContract.RegisterInvoicee.OrgNr"), "register-invoicee-orgnr", (inp) => {
        const matchValue_2 = [inp.length > 0, props.CountryCode];
        let pattern_matching_result;
        if (matchValue_2[0]) {
            if (matchValue_2[1].ThreeLetter === "SWE") {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                return ((inp.length === 10) && luhn(inp)) ? (new FSharpResult$2(0, void 0)) : (new FSharpResult$2(1, getTranslation("CustomerContract.RegisterInvoicee.OrgNrInvalid")));
            }
            case 1: {
                return new FSharpResult$2(0, void 0);
            }
        }
    }, inputRecord.DynamicWidth, singleton_1(["data-regression", "register-invoicee-orgnr-input"]), inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))), react.createElement("div", {
        className: "mt-4",
    }, creditCheckStatusMsgHtml)], react.createElement("div", {
        className: "section__orgnr",
    }, ...children_3))], react.createElement("div", {
        className: "d-flex align-items-center",
    }, ...children_5)), (children_11 = [(children_7 = [main(new ButtonProps(patternInput[0], defaultProps.Content, patternInput[2], ((orgNrState[0]) === "") ? true : patternInput[1], "credit-check-check-button", defaultProps.SaveStatus, singleton_1(["data-regression", "register-invoicee-credit-check-button"]), defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("div", {
        className: "section__button",
    }, ...children_7)), (children_9 = [secondary(new ButtonProps(getTranslation("CustomerContract.RegisterInvoicee.Skip"), defaultProps.Content, (_arg_3) => {
        props.GoToNextSectionFn();
    }, defaultProps.Disabled, "credit-check-skip-button", defaultProps.SaveStatus, singleton_1(["data-regression", "register-invoicee-skip-button"]), defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("div", {
        className: "section__button",
    }, ...children_9))], react.createElement("div", {
        className: "d-flex mt-4",
    }, ...children_11))];
    return react.createElement("div", {
        className: "container__section flex-column",
    }, ...children_13);
}, "CreditCheckSection", uncurry(2, void 0), void 0, "renderCreditCheckSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\RegisterInvoicee\\View2.fs", 363);

export class InvoiceeFormFieldsInitState extends Record {
    constructor(OrgNr, Address, Name, City, ZipCode) {
        super();
        this.OrgNr = OrgNr;
        this.Address = Address;
        this.Name = Name;
        this.City = City;
        this.ZipCode = ZipCode;
    }
}

export function InvoiceeFormFieldsInitState$reflection() {
    return record_type("Containers.RegisterInvoicee.View2.InvoiceeFormFieldsInitState", [], InvoiceeFormFieldsInitState, () => [["OrgNr", string_type], ["Address", string_type], ["Name", string_type], ["City", string_type], ["ZipCode", string_type]]);
}

export class InvoiceeFormFieldsProps extends Record {
    constructor(Countries, GlobalDependencies, InitState, RegisterInvoiceeFn) {
        super();
        this.Countries = Countries;
        this.GlobalDependencies = GlobalDependencies;
        this.InitState = InitState;
        this.RegisterInvoiceeFn = RegisterInvoiceeFn;
    }
}

export function InvoiceeFormFieldsProps$reflection() {
    return record_type("Containers.RegisterInvoicee.View2.InvoiceeFormFieldsProps", [], InvoiceeFormFieldsProps, () => [["Countries", list_type(Country$reflection())], ["GlobalDependencies", GlobalDependencies$reflection()], ["InitState", InvoiceeFormFieldsInitState$reflection()], ["RegisterInvoiceeFn", lambda_type(string_type, lambda_type(string_type, lambda_type(CreateInvoiceeDTO$reflection(), unit_type)))]]);
}

const renderInvoiceeFormFieldsSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let matchValue, _arg_1, _arg_2, threeLetterCountryCode, matchValue_1, inputRecord, LabelText, inputRecord_1, LabelText_1, inputRecord_2, LabelText_2, inputRecord_3, LabelText_3, inputRecord_4, inputRecord_5, LabelText_5, inputRecord_6, LabelText_6, inputRecord_7, LabelText_7, children_21, inputRecord_8, LabelText_8, children_23, inputRecord_9, LabelText_9, inputRecord_10, inputRecord_11, matchValue_4, inputRecord_12, inputRecord_13, LabelText_13, inputRecord_14, inputRecord_15, inputRecord_16, LabelText_16, inputRecord_17, LabelText_17, inputRecord_18, LabelText_18, inputRecord_19, LabelText_19, children_57, children_77, children_71, children_59, children_67, children_65, children_75, children_73;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const nameState = react.useState(props.InitState.Name);
    const orgNrState = react.useState(props.InitState.OrgNr);
    const invoiceeNrState = react.useState("");
    const customerGroupCodeState = react.useState("");
    const invoiceeCountryState = react.useState(props.GlobalDependencies.CountryCode.ThreeLetter);
    const coState = react.useState("");
    const streetAddressState = react.useState(props.InitState.Address);
    const zipCodeState = react.useState(props.InitState.ZipCode);
    const cityState = react.useState(props.InitState.City);
    const postalCountryState = react.useState(props.GlobalDependencies.CountryCode.ThreeLetter);
    const distributionState = react.useState(new Distribution(0));
    const peppolAddressState = react.useState("");
    const referenceState = react.useState("");
    const contactPersonState = react.useState("");
    const contactNumberState = react.useState("");
    const emailState = react.useState("");
    const validationErrorMessagesState = react.useState(empty());
    const errorModalState = react.useState(void 0);
    const choiceModalState = react.useState(void 0);
    const invoiceeTypeState = react.useState(defaultArgWith(InvoiceeTypeModule_ofStringSafe(props.GlobalDependencies.ClientConfig.RegisterInvoiceeDefaultInvoiceeType), () => {
        const _arg = tryHead(InvoiceeTypeModule_getOptions(getTranslation));
        if (_arg != null) {
            return InvoiceeTypeModule_ofString(_arg[0]);
        }
        else {
            throw (new Error("[RegisterInvoicee] Cannot find InvoiceeType."));
        }
    }));
    const vatModeState = react.useState((matchValue = (invoiceeTypeState[0]), (matchValue.tag === 1) ? (new VatMode(1)) : (new VatMode(0))));
    const invoiceIntervalState = react.useState((_arg_1 = tryHead(BillingIntervalModule_getMonthlyBillingIntervalOptions(getTranslation)), (_arg_1 != null) ? _arg_1[0] : (() => {
        throw (new Error("[RegisterInvoicee] Cannot find MonthlyBillingInterval."));
    })()));
    const invoiceStatusState = react.useState((_arg_2 = tryHead(NoNextInvoice_getNoNextInvoiceOptions(getTranslation)), (_arg_2 != null) ? _arg_2[0] : (() => {
        throw (new Error("[RegisterInvoicee] Cannot find NoNextInvoice."));
    })()));
    const validation = new DetailsValidation2((str_2) => String40Module_create(getTranslation, str_2), (str_3) => InvoiceeNrModule_create(props.GlobalDependencies.ClientConfig.AllowAddInvoiceeNr, getTranslation, str_3), (str_4) => OrganisationNumberModule_create(getTranslation, props.GlobalDependencies.CountryCode, str_4), (str_5) => CustomerGroupCodeModule_create(getTranslation, str_5), (str_6) => String32OrEmptyModule_create(getTranslation, str_6), (str_7) => ContactNumberModule_create(getTranslation, str_7), (str_8) => EmailModule_create(getTranslation, str_8), (str_9) => PostalAttentionModule_create(getTranslation, str_9), (str_10) => AlphaNumeric40Module_create(getTranslation, str_10), (threeLetterCountryCode = (postalCountryState[0]), (str_11) => ZipCodeModule_create(getTranslation, threeLetterCountryCode, str_11)), (str_12) => CityModule_create(getTranslation, str_12), (matchValue_1 = [invoiceeTypeState[0], distributionState[0]], (matchValue_1[0].tag === 1) ? ((matchValue_1[1].tag === 4) ? ((str_13) => PeppolIdModule_createNonEmpty(getTranslation, str_13)) : ((str_14) => PeppolIdModule_create(getTranslation, str_14))) : ((str_14) => PeppolIdModule_create(getTranslation, str_14))), (str_15) => String32OrEmptyModule_create(getTranslation, str_15), (str_16) => String32OrEmptyModule_create(getTranslation, str_16), (str_17) => EmptyOrRange1To31Module_create(getTranslation, str_17));
    const vm = new DetailsSectionViewModel(nameState[0], invoiceeTypeState[0], orgNrState[0], invoiceeNrState[0], invoiceeCountryState[0], customerGroupCodeState[0], contactPersonState[0], contactNumberState[0], emailState[0], streetAddressState[0], zipCodeState[0], cityState[0], coState[0], postalCountryState[0], vatModeState[0], distributionState[0], peppolAddressState[0], invoiceIntervalState[0], invoiceStatusState[0], referenceState[0], "", "");
    let generalHeaderHtml;
    const children = [getTranslation("CustomerContract.RegisterInvoicee.General")];
    generalHeaderHtml = react.createElement("h4", {
        className: "section__heading",
        ["data-translation"]: "CustomerContract.RegisterInvoicee.General",
    }, ...children);
    let nameHtml;
    const children_2 = [render_1()((inputRecord = TextProps$1_GetDefault(), (LabelText = (getTranslation("CustomerContract.RegisterInvoicee.Name") + " *"), new TextProps$1(nameState[0], inputRecord.Type, inputRecord.Classes, (e) => {
        const arg_4 = Browser_Types_Event__Event_get_Value(e);
        nameState[1](arg_4);
    }, inputRecord.Disabled, LabelText, "invoicee-details-name", validation.Name, true, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))))];
    nameHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_2);
    let orgNrHtml;
    const children_4 = [render_1()((inputRecord_1 = TextProps$1_GetDefault(), (LabelText_1 = (getTranslation("CustomerContract.RegisterInvoicee.OrgNr") + " *"), new TextProps$1(orgNrState[0], inputRecord_1.Type, inputRecord_1.Classes, (e_1) => {
        const arg_5 = ssnOrOrgNrToValidFormat(Browser_Types_Event__Event_get_Value(e_1), props.GlobalDependencies.CountryCode);
        orgNrState[1](arg_5);
    }, inputRecord_1.Disabled, LabelText_1, "invoicee-details-orgnr", validation.OrgNr, inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, (_arg_4) => {
        const arg_6 = getInvoiceeTypeAndFormattedSSN(props.GlobalDependencies.CountryCode, orgNrState[0])[1];
        orgNrState[1](arg_6);
    }, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name))))];
    orgNrHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_4);
    let invoiceeNrHtml;
    const children_6 = [render_1()((inputRecord_2 = TextProps$1_GetDefault(), (LabelText_2 = (getTranslation("Common.InvoiceeNr") + " *"), new TextProps$1(invoiceeNrState[0], inputRecord_2.Type, inputRecord_2.Classes, (e_2) => {
        const arg_7 = Browser_Types_Event__Event_get_Value(e_2);
        invoiceeNrState[1](arg_7);
    }, inputRecord_2.Disabled, LabelText_2, "invoicee-details-invoiceenr", validation.InvoiceeNr, inputRecord_2.DynamicWidth, inputRecord_2.HTMLProps, inputRecord_2.OnBlur, inputRecord_2.OnFocus, inputRecord_2.AutoComplete, inputRecord_2.Name))))];
    invoiceeNrHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_6);
    let invoiceeTypeHtml;
    const children_8 = [selectOption((inputRecord_3 = SelectOption_get_getDefault(), (LabelText_3 = getTranslation("CustomerContract.RegisterInvoicee.InvoiceeType"), new SelectOption(new ValueProp_6(0, InvoiceeTypeModule_toString(invoiceeTypeState[0]), (e_3) => {
        const invoiceeType_1 = InvoiceeTypeModule_ofString(Browser_Types_Event__Event_get_Value(e_3));
        const vatMode = (invoiceeType_1.tag === 1) ? (new VatMode(1)) : (new VatMode(0));
        invoiceeTypeState[1](invoiceeType_1);
        vatModeState[1](vatMode);
    }), "register-invoicee-type", InvoiceeTypeModule_getOptions(getTranslation), inputRecord_3.Classes, LabelText_3, inputRecord_3.Disabled, inputRecord_3.HTMLProps))))];
    invoiceeTypeHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_8);
    let generalCountryHtml;
    const children_10 = [selectOption((inputRecord_4 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_6(0, invoiceeCountryState[0], (e_4) => {
        const arg_8 = Browser_Types_Event__Event_get_Value(e_4);
        invoiceeCountryState[1](arg_8);
    }), "register-invoicee-country", cons(["", getTranslation("CustomerContract.RegisterInvoicee.ChooseCountry")], countryOptions(props.Countries)), inputRecord_4.Classes, getTranslation("Common.Country"), inputRecord_4.Disabled, inputRecord_4.HTMLProps)))];
    generalCountryHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_10);
    let customerGroupCodeHtml;
    if (props.GlobalDependencies.ClientConfig.HasCustomerGroupCode) {
        const children_12 = [render_1()((inputRecord_5 = TextProps$1_GetDefault(), (LabelText_5 = getTranslation("CustomerContract.RegisterInvoicee.CustomerGroup"), new TextProps$1(customerGroupCodeState[0], inputRecord_5.Type, inputRecord_5.Classes, (e_5) => {
            const arg_9 = Browser_Types_Event__Event_get_Value(e_5);
            customerGroupCodeState[1](arg_9);
        }, inputRecord_5.Disabled, LabelText_5, "register-invoicee-customer-group-code", validation.CustomerGroupCode, inputRecord_5.DynamicWidth, inputRecord_5.HTMLProps, inputRecord_5.OnBlur, inputRecord_5.OnFocus, inputRecord_5.AutoComplete, inputRecord_5.Name))))];
        customerGroupCodeHtml = react.createElement("div", {
            className: "invoicee-details__field",
        }, ...children_12);
    }
    else {
        customerGroupCodeHtml = react.createElement(react.Fragment, {});
    }
    let addressHeaderHtml;
    const children_15 = [getTranslation("Common.Address")];
    addressHeaderHtml = react.createElement("h4", {
        className: "section__heading",
        ["data-translation"]: "Common.Address",
    }, ...children_15);
    let coHtml;
    const children_17 = [render_1()((inputRecord_6 = TextProps$1_GetDefault(), (LabelText_6 = getTranslation("CustomerContract.RegisterInvoicee.CO"), new TextProps$1(coState[0], inputRecord_6.Type, inputRecord_6.Classes, (e_6) => {
        const arg_10 = Browser_Types_Event__Event_get_Value(e_6);
        coState[1](arg_10);
    }, inputRecord_6.Disabled, LabelText_6, "invoicee-details-co", validation.CO, true, inputRecord_6.HTMLProps, inputRecord_6.OnBlur, inputRecord_6.OnFocus, inputRecord_6.AutoComplete, inputRecord_6.Name))))];
    coHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_17);
    let streetHtml;
    const children_19 = [render_1()((inputRecord_7 = TextProps$1_GetDefault(), (LabelText_7 = (getTranslation("CustomerContract.RegisterInvoicee.StreetAddress") + " *"), new TextProps$1(streetAddressState[0], inputRecord_7.Type, inputRecord_7.Classes, (e_7) => {
        const arg_11 = Browser_Types_Event__Event_get_Value(e_7);
        streetAddressState[1](arg_11);
    }, inputRecord_7.Disabled, LabelText_7, "invoicee-details-street", validation.Address, true, inputRecord_7.HTMLProps, inputRecord_7.OnBlur, inputRecord_7.OnFocus, inputRecord_7.AutoComplete, inputRecord_7.Name))))];
    streetHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_19);
    let zipAndCityHtml;
    const children_25 = [(children_21 = [render_1()((inputRecord_8 = TextProps$1_GetDefault(), (LabelText_8 = (getTranslation("CustomerContract.RegisterInvoicee.ZipCode") + " *"), new TextProps$1(zipCodeState[0], inputRecord_8.Type, inputRecord_8.Classes, (e_8) => {
        const arg_12 = replace(Browser_Types_Event__Event_get_Value(e_8).trim(), " ", "");
        zipCodeState[1](arg_12);
    }, inputRecord_8.Disabled, LabelText_8, "invoicee-details-zip", validation.ZipCode, inputRecord_8.DynamicWidth, inputRecord_8.HTMLProps, inputRecord_8.OnBlur, inputRecord_8.OnFocus, inputRecord_8.AutoComplete, inputRecord_8.Name))))], react.createElement("div", {
        className: "field__short",
    }, ...children_21)), (children_23 = [render_1()((inputRecord_9 = TextProps$1_GetDefault(), (LabelText_9 = (getTranslation("Common.City") + " *"), new TextProps$1(cityState[0], inputRecord_9.Type, inputRecord_9.Classes, (e_9) => {
        const arg_13 = Browser_Types_Event__Event_get_Value(e_9);
        cityState[1](arg_13);
    }, inputRecord_9.Disabled, LabelText_9, "invoicee-details-city", validation.City, true, inputRecord_9.HTMLProps, inputRecord_9.OnBlur, inputRecord_9.OnFocus, inputRecord_9.AutoComplete, inputRecord_9.Name))))], react.createElement("div", {}, ...children_23))];
    zipAndCityHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_25);
    let postalCountryHtml;
    const children_27 = [selectOption((inputRecord_10 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_6(0, postalCountryState[0], (e_10) => {
        const arg_14 = Browser_Types_Event__Event_get_Value(e_10);
        postalCountryState[1](arg_14);
    }), "register-postal-country", cons(["", getTranslation("CustomerContract.RegisterInvoicee.ChooseCountry")], countryOptions(filter((country) => (country.Code.TwoLetter !== "O1"), props.Countries))), inputRecord_10.Classes, getTranslation("Common.Country"), inputRecord_10.Disabled, inputRecord_10.HTMLProps)))];
    postalCountryHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_27);
    let invoiceHeaderHtml;
    const children_29 = [getTranslation("Common.Invoice")];
    invoiceHeaderHtml = react.createElement("h4", {
        className: "section__heading",
        ["data-translation"]: "Common.Invoice",
    }, ...children_29);
    let vatHtml;
    const children_31 = [selectOption((inputRecord_11 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_6(0, VatModeModule_toString(vatModeState[0]), (e_11) => {
        const arg_15 = VatModeModule_ofString(Browser_Types_Event__Event_get_Value(e_11));
        vatModeState[1](arg_15);
    }), "register-invoicee-vat", VatModeModule_getOptions(getTranslation), inputRecord_11.Classes, getTranslation("CustomerContract.RegisterInvoicee.Vat"), inputRecord_11.Disabled, inputRecord_11.HTMLProps)))];
    vatHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_31);
    let distributionHtml;
    if ((matchValue_4 = props.GlobalDependencies.ClientConfig.OmniChannel, (matchValue_4 == null) ? false : (matchValue_4 > 10))) {
        distributionHtml = react.createElement(react.Fragment, {});
    }
    else {
        const children_34 = [selectOption((inputRecord_12 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_6(0, DistributionModule_toString(distributionState[0]), (e_12) => {
            const arg_16 = DistributionModule_ofString(Browser_Types_Event__Event_get_Value(e_12));
            distributionState[1](arg_16);
        }), "register-invoicee-distribution", DistributionModule_getOptions(getTranslation, props.GlobalDependencies.CountryCode, invoiceeTypeState[0], props.GlobalDependencies.ClientConfig.UsesPeppol, props.GlobalDependencies.ClientConfig.EnableEInvoiceIdentifier), inputRecord_12.Classes, getTranslation("CustomerContract.RegisterInvoicee.Distribution"), inputRecord_12.Disabled, inputRecord_12.HTMLProps)))];
        distributionHtml = react.createElement("div", {
            className: "invoicee-details__field",
        }, ...children_34);
    }
    let peppolAddressHtml;
    if (equals(distributionState[0], new Distribution(4))) {
        const children_36 = [render_1()((inputRecord_13 = TextProps$1_GetDefault(), (LabelText_13 = (getTranslation("CustomerContract.RegisterInvoicee.PeppolAddress") + " *"), new TextProps$1(peppolAddressState[0], inputRecord_13.Type, inputRecord_13.Classes, (e_13) => {
            const arg_17 = Browser_Types_Event__Event_get_Value(e_13);
            peppolAddressState[1](arg_17);
        }, inputRecord_13.Disabled, LabelText_13, "invoicee-details-peppol-address", validation.PeppolAddress, inputRecord_13.DynamicWidth, inputRecord_13.HTMLProps, inputRecord_13.OnBlur, inputRecord_13.OnFocus, inputRecord_13.AutoComplete, inputRecord_13.Name))))];
        peppolAddressHtml = react.createElement("div", {
            className: "invoicee-details__field",
        }, ...children_36);
    }
    else {
        peppolAddressHtml = react.createElement(react.Fragment, {});
    }
    let intervalHtml;
    const children_39 = [selectOption((inputRecord_14 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_6(0, invoiceIntervalState[0], (e_14) => {
        const arg_18 = Browser_Types_Event__Event_get_Value(e_14);
        invoiceIntervalState[1](arg_18);
    }), "register-invoicee-invoice-interval", BillingIntervalModule_getMonthlyBillingIntervalOptions(getTranslation), inputRecord_14.Classes, getTranslation("CustomerContract.RegisterInvoicee.InvoiceInterval"), inputRecord_14.Disabled, inputRecord_14.HTMLProps)))];
    intervalHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_39);
    let statusHtml;
    const children_41 = [selectOption((inputRecord_15 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_6(0, invoiceStatusState[0], (e_15) => {
        const arg_19 = Browser_Types_Event__Event_get_Value(e_15);
        invoiceStatusState[1](arg_19);
    }), "register-invoicee-invoice-status", NoNextInvoice_getNoNextInvoiceOptions(getTranslation), inputRecord_15.Classes, getTranslation("CustomerContract.RegisterInvoicee.InvoiceStatus"), inputRecord_15.Disabled, inputRecord_15.HTMLProps)))];
    statusHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_41);
    let referenceHtml;
    const children_43 = [render_1()((inputRecord_16 = TextProps$1_GetDefault(), (LabelText_16 = getTranslation("CustomerContract.RegisterInvoicee.InvoiceReference"), new TextProps$1(referenceState[0], inputRecord_16.Type, inputRecord_16.Classes, (e_16) => {
        const arg_20 = Browser_Types_Event__Event_get_Value(e_16);
        referenceState[1](arg_20);
    }, inputRecord_16.Disabled, LabelText_16, "invoicee-details-reference", validation.Reference, true, inputRecord_16.HTMLProps, inputRecord_16.OnBlur, inputRecord_16.OnFocus, inputRecord_16.AutoComplete, inputRecord_16.Name))))];
    referenceHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_43);
    let contactHeaderHtml;
    const children_45 = [getTranslation("Common.ContactDetails")];
    contactHeaderHtml = react.createElement("h4", {
        className: "section__heading mt-5",
        ["data-translation"]: "Common.ContactDetails",
    }, ...children_45);
    let contactPersonHtml;
    const children_47 = [render_1()((inputRecord_17 = TextProps$1_GetDefault(), (LabelText_17 = getTranslation("CustomerContract.RegisterInvoicee.ContactPerson"), new TextProps$1(contactPersonState[0], inputRecord_17.Type, inputRecord_17.Classes, (e_17) => {
        const arg_21 = Browser_Types_Event__Event_get_Value(e_17);
        contactPersonState[1](arg_21);
    }, inputRecord_17.Disabled, LabelText_17, "invoicee-details-contact-person", validation.ContactPerson, true, inputRecord_17.HTMLProps, inputRecord_17.OnBlur, inputRecord_17.OnFocus, inputRecord_17.AutoComplete, inputRecord_17.Name))))];
    contactPersonHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_47);
    let contactNumberHtml;
    const children_49 = [render_1()((inputRecord_18 = TextProps$1_GetDefault(), (LabelText_18 = getTranslation("CustomerContract.RegisterInvoicee.ContactNumber"), new TextProps$1(contactNumberState[0], inputRecord_18.Type, inputRecord_18.Classes, (e_18) => {
        const arg_22 = Browser_Types_Event__Event_get_Value(e_18).trim();
        contactNumberState[1](arg_22);
    }, inputRecord_18.Disabled, LabelText_18, "invoicee-details-contact-number", validation.ContactNumber, inputRecord_18.DynamicWidth, inputRecord_18.HTMLProps, inputRecord_18.OnBlur, inputRecord_18.OnFocus, inputRecord_18.AutoComplete, inputRecord_18.Name))))];
    contactNumberHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_49);
    let emailHtml;
    const children_51 = [render_1()((inputRecord_19 = TextProps$1_GetDefault(), (LabelText_19 = getTranslation("CustomerContract.RegisterInvoicee.Email"), new TextProps$1(emailState[0], inputRecord_19.Type, inputRecord_19.Classes, (e_19) => {
        const arg_23 = Browser_Types_Event__Event_get_Value(e_19).trim();
        emailState[1](arg_23);
    }, inputRecord_19.Disabled, LabelText_19, "invoicee-details-email", validation.Email, true, inputRecord_19.HTMLProps, inputRecord_19.OnBlur, inputRecord_19.OnFocus, inputRecord_19.AutoComplete, inputRecord_19.Name))))];
    emailHtml = react.createElement("div", {
        className: "invoicee-details__field",
    }, ...children_51);
    let choiceModalHtml;
    const matchValue_6 = choiceModalState[0];
    if (matchValue_6 != null) {
        const warningMsg = matchValue_6[0];
        const continueFn_1 = matchValue_6[1];
        choiceModalHtml = renderModal(getTranslation("Common.WarningMessage"), react.createElement("p", {}, warningMsg), getTranslation("Common.Cancel"), getTranslation("Common.Create"), (_arg_8) => {
            choiceModalState[1](void 0);
            continueFn_1(false);
        }, (_arg_9) => {
            choiceModalState[1](void 0);
            continueFn_1(true);
        });
    }
    else {
        choiceModalHtml = react.createElement(react.Fragment, {});
    }
    let errorModalHtml;
    const matchValue_7 = errorModalState[0];
    if (matchValue_7 != null) {
        const errorMsg = matchValue_7;
        errorModalHtml = modal(true, render_2(getTranslation("Common.ErrorMessage"), (children_57 = [stripHtmlTags(errorMsg.split(""))], react.createElement("p", {}, ...children_57)), new MessageType(2), "Ok", (_arg_10) => {
            errorModalState[1](void 0);
        }));
    }
    else {
        errorModalHtml = react.createElement(react.Fragment, {});
    }
    const children_79 = [(children_77 = [(children_71 = [(children_59 = toList(delay(() => append(singleton_2(generalHeaderHtml), delay(() => append(singleton_2(nameHtml), delay(() => append(singleton_2(orgNrHtml), delay(() => append(props.GlobalDependencies.ClientConfig.AllowAddInvoiceeNr ? singleton_2(invoiceeNrHtml) : empty_1(), delay(() => append(singleton_2(invoiceeTypeHtml), delay(() => append(singleton_2(generalCountryHtml), delay(() => singleton_2(customerGroupCodeHtml))))))))))))))), react.createElement("div", {
        className: "invoicee-details col",
    }, ...children_59)), (children_67 = [(children_65 = [react.createElement("div", {}, addressHeaderHtml, coHtml, streetHtml, zipAndCityHtml, postalCountryHtml), react.createElement("div", {}, contactHeaderHtml, contactNumberHtml, emailHtml, contactPersonHtml)], react.createElement("div", {
        className: "d-flex flex-column",
    }, ...children_65))], react.createElement("div", {
        className: "invoicee-details col",
    }, ...children_67)), react.createElement("div", {
        className: "invoicee-details col",
    }, invoiceHeaderHtml, vatHtml, distributionHtml, peppolAddressHtml, intervalHtml, statusHtml, referenceHtml)], react.createElement("div", {
        className: "d-flex mb-5 row",
    }, ...children_71)), (children_75 = [wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("CustomerContract.RegisterInvoicee.CreateInvoicee"), defaultProps.Content, (_arg_11) => {
        let matchValue_2, orgNr_1, matchValue_3, msgs, dto, generalCountryCode, addressCountryCode, msg_1, arg_3;
        const validDetailsResult = getValidDetails(getTranslation, vm, validation);
        const arg = (validDetailsResult.tag === 1) ? validDetailsResult.fields[0] : empty();
        validationErrorMessagesState[1](arg);
        startImmediate((matchValue_2 = (orgNrState[0]), (matchValue_2 !== "") ? ((orgNr_1 = matchValue_2, (matchValue_3 = getValidDetails(getTranslation, vm, validation), (matchValue_3.tag === 1) ? ((msgs = matchValue_3.fields[0], (logwi(msgs), (validationErrorMessagesState[1](msgs), singleton.Return())))) : ((dto = getCreateInvoiceeDTO(props.GlobalDependencies.ClientConfig.OmniChannel, props.GlobalDependencies.LanguageCode, matchValue_3.fields[0]), (generalCountryCode = (invoiceeCountryState[0]), (addressCountryCode = (postalCountryState[0]), singleton.Delay(() => {
            const isOtherCountry = (generalCountryCode === "O1 ") ? true : (addressCountryCode === "O1 ");
            return singleton.Combine((isOtherCountry ? true : props.GlobalDependencies.ClientConfig.RegisterInvoiceeSkipDuplicateCheck) ? ((props.RegisterInvoiceeFn(generalCountryCode, orgNr_1, dto), singleton.Zero())) : singleton.Bind(loadExistingInvoicee(props.GlobalDependencies.ClientNr, generalCountryCode, orgNr_1), (_arg_3) => {
                const result = _arg_3;
                if (result.tag === 1) {
                    return singleton.Zero();
                }
                else if (isEmpty(result.fields[0])) {
                    props.RegisterInvoiceeFn(generalCountryCode, orgNr_1, dto);
                    return singleton.Zero();
                }
                else {
                    let msg;
                    const arg_2 = getTranslation("CustomerContract.RegisterInvoicee.ErrorExistingOrgNr2");
                    const arg_1 = getTranslation("CustomerContract.RegisterInvoicee.ErrorExistingOrgNr");
                    msg = toText(printf("%s. %s "))(arg_1)(arg_2);
                    choiceModalState[1]([msg, (shouldContinue) => {
                        if (shouldContinue) {
                            props.RegisterInvoiceeFn(generalCountryCode, orgNr_1, dto);
                        }
                    }]);
                    return singleton.Zero();
                }
            }), singleton.Delay(() => {
                validationErrorMessagesState[1](empty());
                return singleton.Zero();
            }));
        })))))))) : ((msg_1 = ((arg_3 = getTranslation("CustomerContract.RegisterInvoicee.CreateInvoiceeError"), toText(printf("%s [OrgNr]"))(arg_3))), (errorModalState[1](msg_1), singleton.Return())))));
    }, defaultProps.Disabled, "register-invoicee-create-btn", defaultProps.SaveStatus, singleton_1(["data-regression", "register-invoicee-create-button"]), defaultProps.ExtraClasses, defaultProps.Icon)), (children_73 = [errors(validationErrorMessagesState[0])], react.createElement("div", {
        className: "mt-2",
    }, ...children_73))], react.createElement("div", {}, ...children_75))], react.createElement("div", {
        className: "d-flex flex-column w-100",
    }, ...children_77)), errorModalHtml, choiceModalHtml];
    return react.createElement("div", {
        className: "container__section",
        ["data-regression"]: "register-invoicee-form",
    }, ...children_79);
}, "InvoiceeFormFieldsSection", uncurry(2, void 0), void 0, "renderInvoiceeFormFieldsSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\RegisterInvoicee\\View2.fs", 956);

function getRegisterStatusSection(getTranslation, saveItems, onClickDone, onClickBack) {
    const savePanelHtml = getSavePanel(getTranslation("CustomerContract.RegisterInvoicee.CreatingInvoicee"), saveItems);
    const goToButtonHtml = forAll((item) => (!equals(item[1], new SaveStatus(2))), saveItems) ? main(new ButtonProps(getTranslation("CustomerContract.RegisterInvoicee.GoToForm"), defaultProps.Content, onClickBack, defaultProps.Disabled, "register-invoicee-go-to-form-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : main(new ButtonProps(getTranslation("CustomerContract.RegisterInvoicee.GoToInvoicee"), defaultProps.Content, onClickDone, defaultProps.Disabled, "register-invoicee-go-to-invoicee-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
    const children_4 = [react.createElement("div", {}, savePanelHtml), react.createElement("div", {}, goToButtonHtml)];
    return react.createElement("div", {
        className: "register-invoicee__status-section",
    }, ...children_4);
}

function getSection(heading, state, innerHtml, onHeadingClick) {
    let children_7, children_5;
    const innerHtml$0027 = (state.tag === 2) ? react.createElement(react.Fragment, {}) : ((state.tag === 0) ? react.createElement(react.Fragment, {}) : react.createElement("div", {}, innerHtml));
    const children_11 = [(children_7 = [(children_5 = [getProgressIcon(state), react.createElement("h3", {
        className: "section-heading",
        onClick: onHeadingClick,
    }, heading)], react.createElement("div", {
        className: "d-flex align-items-center",
    }, ...children_5))], react.createElement("div", {
        className: "section-container",
    }, ...children_7)), react.createElement("div", {
        className: "section-container",
    }, innerHtml$0027)];
    return react.createElement("div", {
        className: "register-invoicee__section",
    }, ...children_11);
}

export class RegisterInvoiceeProps extends Record {
    constructor(GlobalDependencies) {
        super();
        this.GlobalDependencies = GlobalDependencies;
    }
}

export function RegisterInvoiceeProps$reflection() {
    return record_type("Containers.RegisterInvoicee.View2.RegisterInvoiceeProps", [], RegisterInvoiceeProps, () => [["GlobalDependencies", GlobalDependencies$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2;
    const reduxDispatch = useDispatch();
    const countriesLoadState = useSelector((state) => state.Model.Countries);
    const translationsLoadState = useSelector((state_1) => state_1.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const currentSectionState = react.useState(props.GlobalDependencies.ClientConfig.UsesCreditCheck ? (new Section(0)) : (new Section(1)));
    const creditCheckSectionState = react.useState(props.GlobalDependencies.ClientConfig.UsesCreditCheck ? (new SectionState(1, 1)) : (new SectionState(0)));
    const detailsSectionState = react.useState(props.GlobalDependencies.ClientConfig.UsesCreditCheck ? (new SectionState(2, 2)) : (new SectionState(1, 1)));
    const creditSectionOrgNrState = react.useState("");
    const registerInvoiceeLoadState = react.useState(new LoadState$2(0));
    const detailsSectionStateDefaultNr = (props.GlobalDependencies.ClientConfig.UsesCreditCheck ? 2 : 1) | 0;
    const creditCheckSectionDefaultNr = (props.GlobalDependencies.ClientConfig.UsesCreditCheck ? 1 : 0) | 0;
    const creditCheckLoadState = react.useState(new LoadState$2(0));
    react.useEffect(() => {
        switch (countriesLoadState.tag) {
            case 0:
            case 3: {
                reduxDispatch(loadCountriesThunk());
                break;
            }
            default: {
            }
        }
    }, []);
    const goToSection = (fromSection, toSection) => {
        let arg_2, arg_1;
        currentSectionState[1](toSection);
        const matchValue = [fromSection, toSection];
        let pattern_matching_result;
        if (matchValue[1].tag === 1) {
            if (matchValue[0].tag === 0) {
                pattern_matching_result = 1;
            }
            else if (matchValue[0].tag === 2) {
                pattern_matching_result = 4;
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else if (matchValue[1].tag === 0) {
            if (matchValue[0].tag === 1) {
                pattern_matching_result = 2;
            }
            else if (matchValue[0].tag === 2) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else {
            pattern_matching_result = 0;
        }
        switch (pattern_matching_result) {
            case 0: {
                creditCheckSectionState[1](new SectionState(0));
                detailsSectionState[1](new SectionState(0));
                break;
            }
            case 1: {
                creditCheckSectionState[1](new SectionState(0));
                detailsSectionState[1](new SectionState(1, detailsSectionStateDefaultNr));
                break;
            }
            case 2: {
                creditCheckSectionState[1](new SectionState(1, creditCheckSectionDefaultNr));
                detailsSectionState[1](new SectionState(2, detailsSectionStateDefaultNr));
                break;
            }
            case 3: {
                creditCheckSectionState[1](new SectionState(1, creditCheckSectionDefaultNr));
                break;
            }
            case 4: {
                detailsSectionState[1](new SectionState(1, detailsSectionStateDefaultNr));
                break;
            }
            case 5: {
                logwi((arg_2 = toString(toSection), (arg_1 = toString(fromSection), toText(printf("Unexpected navigation from %s to %s"))(arg_1)(arg_2))));
                break;
            }
        }
    };
    const creditCheckSectionHtml = props.GlobalDependencies.ClientConfig.UsesCreditCheck ? getSection(getTranslation("CustomerContract.RegisterInvoicee.CreditCheck"), creditCheckSectionState[0], renderCreditCheckSection(new CreditCheckSectionProps(locale, props.GlobalDependencies.CountryCode, (orgNr) => {
        creditCheckLoadState[1](new LoadState$2(1));
        return singleton.Delay(() => singleton.Bind(loadCreditCheck_1(props.GlobalDependencies.ClientNr, props.GlobalDependencies.CountryCode.ThreeLetter, orgNr), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
            creditCheckLoadState[1](arg);
            return singleton.Return(result);
        }));
    }, () => {
        goToSection(currentSectionState[0], new Section(1));
    }, (arg_3) => {
        creditSectionOrgNrState[1](arg_3);
    })), (_arg_1) => {
        goToSection(currentSectionState[0], new Section(0));
    }) : react.createElement(react.Fragment, {});
    let detailsSectionHtml;
    let invoiceeFormFieldsInitState;
    const matchValue_1 = creditCheckLoadState[0];
    switch (matchValue_1.tag) {
        case 1:
        case 3: {
            invoiceeFormFieldsInitState = (new InvoiceeFormFieldsInitState(creditSectionOrgNrState[0], "", "", "", ""));
            break;
        }
        case 2: {
            const dto_1 = matchValue_1.fields[0];
            invoiceeFormFieldsInitState = (new InvoiceeFormFieldsInitState(creditSectionOrgNrState[0], dto_1.address, dto_1.full_name, dto_1.postal_city, dto_1.postal_code));
            break;
        }
        default: {
            invoiceeFormFieldsInitState = (new InvoiceeFormFieldsInitState(creditSectionOrgNrState[0], "", "", "", ""));
        }
    }
    detailsSectionHtml = getSection(getTranslation("CustomerContract.RegisterInvoicee.InvoiceeDetails"), detailsSectionState[0], renderInvoiceeFormFieldsSection(new InvoiceeFormFieldsProps(LoadState_defaultValue(empty(), countriesLoadState), props.GlobalDependencies, invoiceeFormFieldsInitState, (threeLetterCountryCode, orgNr_1, dto) => {
        registerInvoiceeLoadState[1](new LoadState$2(1));
        goToSection(currentSectionState[0], new Section(2));
        startImmediate(singleton.Delay(() => singleton.Bind(saveNewInvoicee(props.GlobalDependencies.ClientNr, threeLetterCountryCode, orgNr_1, dto), (_arg_2) => {
            const result_1 = _arg_2;
            const arg_4 = (result_1.tag === 0) ? (new LoadState$2(2, result_1.fields[0])) : (new LoadState$2(3, result_1.fields[0]));
            registerInvoiceeLoadState[1](arg_4);
            return singleton.Zero();
        })));
    })), (_arg_3) => {
        goToSection(currentSectionState[0], new Section(1));
    });
    let saveStatusModalHtml;
    let registerStatusText;
    const matchValue_2 = registerInvoiceeLoadState[0];
    switch (matchValue_2.tag) {
        case 1: {
            registerStatusText = (getTranslation("CustomerContract.RegisterInvoicee.CreatingInvoicee") + "...");
            break;
        }
        case 2: {
            registerStatusText = (getTranslation("CustomerContract.RegisterInvoicee.InvoiceeCreated") + "!");
            break;
        }
        case 3: {
            registerStatusText = (getTranslation("CustomerContract.RegisterInvoicee.InvoiceeFailed") + ".");
            break;
        }
        default: {
            registerStatusText = (getTranslation("CustomerContract.RegisterInvoicee.WaitingInvoicee") + "...");
        }
    }
    let registerInvoiceeSaveStatus;
    const matchValue_3 = registerInvoiceeLoadState[0];
    switch (matchValue_3.tag) {
        case 1: {
            registerInvoiceeSaveStatus = (new SaveStatus(1));
            break;
        }
        case 2: {
            registerInvoiceeSaveStatus = (new SaveStatus(2));
            break;
        }
        case 3: {
            registerInvoiceeSaveStatus = (new SaveStatus(3, matchValue_3.fields[0]));
            break;
        }
        default: {
            registerInvoiceeSaveStatus = (new SaveStatus(0));
        }
    }
    saveStatusModalHtml = (((currentSectionState[0]).tag === 2) ? modal(true, getModalContainer(new ModalSize(1), getRegisterStatusSection(getTranslation, singleton_1([registerStatusText, registerInvoiceeSaveStatus]), (_arg_4) => {
        let arg_6;
        const matchValue_5 = registerInvoiceeLoadState[0];
        if (matchValue_5.tag === 2) {
            RouterModule_nav(ofArray(["CustomerContract", "Invoicee", toString_1(matchValue_5.fields[0])]), 1, 1);
        }
        else {
            logei((arg_6 = (registerInvoiceeLoadState[0]), toText(printf("[RegisterInvoicee] Cannot find invoiceeNr to navigate to: %A"))(arg_6)));
        }
    }, (_arg_5) => {
        registerInvoiceeLoadState[1](new LoadState$2(0));
        goToSection(new Section(2), new Section(1));
    }))) : react.createElement(react.Fragment, {}));
    const children_6 = [(children_2 = [getTranslation("CustomerContract.RegisterInvoicee")], react.createElement("h2", {
        className: "register-invoicee__heading",
    }, ...children_2)), react.createElement("div", {
        className: "register-invoicee__container",
    }, creditCheckSectionHtml, detailsSectionHtml, saveStatusModalHtml)];
    return react.createElement("div", {
        className: "register-invoicee",
    }, ...children_6);
}, "RegisterInvoiceePage", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\RegisterInvoicee\\View2.fs", 1206);

